import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  hydrated: boolean;
  setToken: (token: string, refreshToken: string) => void;
  clearToken: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      hydrated: false,
      setToken: (token, refreshToken) => set({ token, refreshToken }),
      clearToken: () => set({ token: null, refreshToken: null }),
    }),
    {
      name: "auth-token",
      onRehydrateStorage: () => (state) => {
        state && setTimeout(() => state.hydrated = true, 0);
      },
    }
  )
);
